import { useContext } from 'preact/hooks';

import { IsMobileLayoutContext } from './contexts';

export const useIsMobileLayout = () => useContext(IsMobileLayoutContext) === true;
export const useIsDesktopLayout = () => useContext(IsMobileLayoutContext) !== true;
